import React, { useState } from 'react';
import { useSiteSettings } from '../../lib/api/settings';
import { NETWORKS } from '../../lib/networks';

// "Follow us" links to every social page saved in the back office, plus the Facebook posts on request.
// The Facebook box loads only after a click, so nothing is sent to Facebook until the visitor asks for it.
const SocialBlock = () => {
  const { social } = useSiteSettings();
  const [showFeed, setShowFeed] = useState(false);
  const links = NETWORKS.filter(([key]) => social[key]);
  if (!links.length) return null;
  const facebook = social.facebook && /facebook\.com/i.test(social.facebook) ? social.facebook : null;

  return (
    <div className="sc-social">
      <h4>Follow SANASA Campus</h4>
      <div className="sc-social__links">
        {links.map(([key, label, icon]) => (
          <a key={key} href={social[key]} target="_blank" rel="noreferrer">
            <i className={icon}></i>
            <span>{label}</span>
          </a>
        ))}
      </div>
      {facebook && (
        <div className="sc-social__feed">
          {showFeed ? (
            <iframe
              title="Facebook posts"
              src={`https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebook)}&tabs=timeline&width=500&height=520&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false`}
              width="500"
              height="520"
              loading="lazy"
              allow="encrypted-media"
            ></iframe>
          ) : (
            <button type="button" className="ed-btn-square" onClick={() => setShowFeed(true)}>
              <span>Show our latest Facebook posts</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SocialBlock;
